import { UseQueryResult } from '@tanstack/react-query';

export const ENTITY_STATUS_LOADING = 'loading';
export const ENTITY_STATUS_FOUND = 'found';
export const ENTITY_STATUS_SYNCING = 'syncing';
export const ENTITY_STATUS_DELETED = 'deleted';

export type EntityStatus =
	| typeof ENTITY_STATUS_LOADING
	| typeof ENTITY_STATUS_FOUND
	| typeof ENTITY_STATUS_SYNCING
	| typeof ENTITY_STATUS_DELETED;

export interface IUseEntityStatusQueryOptions<TData extends { name?: string }> {
	queryKey: string[];
	queryFn: () => Promise<TData | null>;
}

export interface IUseEntityStatusQueryResult<TData> {
	query: UseQueryResult<NonNullable<TData>>;
	status: EntityStatus;
}
